import React from "react";

import { faLocationDot } from "@fortawesome/pro-solid-svg-icons/faLocationDot";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useIntl } from "react-intl";

import DistanceUnit from "@mapmycustomers/shared/enum/DistanceUnit";

import { distance } from "@app/util/formatters";
import { getDistanceUnitDisplayName } from "@app/util/ui";

import styles from "./Distance.module.scss";

interface Props {
  unit: DistanceUnit;
  value?: number;
}

const Distance: React.FC<Props> = ({ unit, value }) => {
  const intl = useIntl();

  if (value === undefined || isNaN(value)) {
    return null;
  }

  const formattedUnit = getDistanceUnitDisplayName(intl, unit);
  const formattedValue = distance(intl, value);

  return (
    <div className={styles.container}>
      <FontAwesomeIcon icon={faLocationDot} />
      <span>{formattedValue}</span>
      {formattedUnit}
    </div>
  );
};

export default Distance;
